<template>
    <footer id="footer">
        <nav>
            <router-link :to="{ name: 'home' }">
                <div :class="['nav-item', { active: isHome }]">
                    <v-icon size="24">{{ isHome ? 'mdi-home' : 'mdi-home-outline' }}</v-icon>
                    <span class="nav-label">{{ t('nav.home') }}</span>
                </div>
            </router-link>

            <router-link :to="{ name: 'aquariums' }">
                <div :class="['nav-item', { active: isAquariums }]">
                    <v-icon size="24">{{ isAquariums ? 'mdi-fishbowl' : 'mdi-fishbowl-outline' }}</v-icon>
                    <span class="nav-label">{{ t('nav.aquariums') }}</span>
                </div>
            </router-link>

            <router-link :to="{ name: 'plants' }">
                <div :class="['nav-item', { active: isPlants }]">
                    <v-icon size="24">{{ isPlants ? 'mdi-sprout' : 'mdi-sprout-outline' }}</v-icon>
                    <span class="nav-label">{{ t('nav.plants') }}</span>
                </div>
            </router-link>

            <router-link :to="{ name: 'profile' }">
                <div :class="['nav-item', { active: isProfile }]">
                    <v-icon size="24">{{ isProfile ? 'mdi-account' : 'mdi-account-outline' }}</v-icon>
                    <span class="nav-label">{{ t('nav.profile') }}</span>
                </div>
            </router-link>
        </nav>
    </footer>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const route = useRoute();

const isHome      = computed(() => route.name === "home");
const isAquariums = computed(() => route.name === "aquariums");
const isPlants    = computed(() => route.name === "plants");
const isProfile   = computed(() => route.name === "profile");
</script>

<style scoped lang="scss">
#footer {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 100;
    width: 100%;
    max-width: 600px;
    background-color: #ffffff;
    height: var(--nav-height);
    padding: 0 10px 10px;
    border-top: 0.5px solid var(--color-black-10);

    nav {
        height: 100%;
        display: flex;
        justify-content: space-around;
        align-items: stretch;

        > a {
            text-decoration: none;
            display: flex;
            align-items: stretch;
            flex: 1;
        }
    }
}

.nav-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    flex: 1;
    padding-top: 10px;
    color: var(--color-black-50);

    .v-icon {
        color: var(--color-black-50);
    }

    &.active {
        border-top: 2px solid var(--color-secondary-100);
        color: var(--color-secondary-100);
        padding-top: 8px;

        .v-icon {
            color: var(--color-secondary-100);
        }
    }
}

.nav-label {
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.3px;
}
</style>
